import { ChangeEventHandler, useMemo, useState } from 'react';

import classNames from 'classnames';
import Input from 'src/common/components/Input';

import { usePhoneListContext } from '../context';

interface CampaignsListProps {
  onChange?: (id: string) => void;
  defaultValue?: string | null;
}

export const CampaignsList = ({
  onChange = () => {},
  defaultValue = null,
}: CampaignsListProps): JSX.Element => {
  const [search, setSearch] = useState('');
  const { state } = usePhoneListContext();
  const { campaigns } = state;

  const filteredCampaigns = useMemo(() => {
    if (!search?.trim()) return campaigns;
    return campaigns.filter((campaign) =>
      campaign.id.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())
    );
  }, [search, campaigns]);

  const handleSelectCampaign: ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange(event.target.id);
  };

  const handleSearch = (value: string): void => {
    setSearch(value);
  };

  return (
    <div className="flex flex-col">
      <Input placeholder="Search campaign" onDebounceChange={handleSearch} />
      {!!filteredCampaigns.length && (
        <ul className="h-80 mt-4 overflow-auto">
          {filteredCampaigns.map((campaign, index) => {
            const className = index !== filteredCampaigns.length - 1 ? 'border-b' : '';
            return (
              <li
                key={campaign.id}
                className={classNames(
                  'bg-white-0.0 flex justify-between border-white-2.0 px-2 py-2',
                  className
                )}
              >
                <input
                  type="radio"
                  name="campaignRadio"
                  id={campaign.campaign_id}
                  onChange={handleSelectCampaign}
                  defaultChecked={campaign.campaign_id === defaultValue}
                />
                <label
                  role="presentation"
                  className="flex flex-col flex-1 ml-4 truncate cursor-pointer"
                  htmlFor={campaign.campaign_id}
                >
                  <div>{campaign.campaign_id}</div>
                  <div className="text-xs text-gray-2.0">{campaign.description}</div>
                </label>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
